export const getDefaultLocale = () => {
  const lang = navigator.language
  if (lang === 'zh-TW' || lang === 'zh-HK' || lang === 'zh-MO') return 'zh-TW'
  return lang.split('-')[0]
}
